"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/routing";
import MainLogo from "../ui/logo";

export default function FooterCompanyInfo() {
  const t = useTranslations("footer.company");

  return (
    <div className="flex flex-col items-start gap-2 text-sm text-muted-foreground">
      <Link aria-label="Homepage - thunderproxy" href="/">
        <MainLogo />
      </Link>
      <p>{t("vat")}</p>
      <p>
        Konstitucijos pr. 21B (Quadrum South)
        <br />
        Vilnius
        <br />
        Lithuania, LT-09306
      </p>
    </div>
  );
}
